// Core
import styled from 'styled-components';

// Libraries
import { Drawer as DrawerAntD } from 'antd';

// Layout
import { Col } from '../Col';
import { Row } from '../Row';

// Config
import { BREAKPOINTS } from '../../../config/screen';

// Plugins
import { hexToRgba } from '../../../plugins/general';

// Component
import { DrawerProps } from './Drawer.types';

export const Overlay = styled.div<Pick<DrawerProps, 'open'>>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  backdrop-filter: ${({ open }) => (open ? 'blur(7px)' : 'inherit')};
  z-index: 2;
  pointer-events: none;
`;

export const Header = styled(Col)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const TitleContainer = styled.div`
  justify-content: space-between;
  gap: 1rem;
  display: flex;
`;

export const Element = styled(DrawerAntD)`
  .ant-drawer-header {
    border-bottom: unset;
    padding: 1.75rem 1rem;
    color: ${({ theme }) => theme.color.drawer.colorIcon};

    // Apply larger padding for screens >= sm
    @media (min-width: ${BREAKPOINTS.sm}px) {
      padding: 1.75rem 1.5rem;
    };
  };

  .ant-drawer-wrapper-body {
    position: relative;
  };

  .ant-drawer-body {
    padding: 0 1rem 1rem 1rem;
    scrollbar-gutter: stable;

    // Apply larger padding for screens >= sm
    @media (min-width: ${BREAKPOINTS.sm}px) {
      padding: 0 1.5rem 1.5rem 1.5rem;
    };

    ::-webkit-scrollbar {
      width: 0.438rem;
    };

    ::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 3.375rem;
    };

    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.color.drawer.scrollBackgroundColor};
      border-radius: 3.375rem;
    };
  };

  .ant-drawer-footer {
    display: flex;
    position: relative;
    justify-content: flex-end;
    padding: 0.75rem 1.5rem 1rem 1.5rem;
    border-top: unset;
  };
`;

export const PreviewContainer = styled(Row)`
  margin: 0.75rem 0 1.5rem;
`;

export const PreviewImage = styled.img`
  width: 7.5rem;
  height: 7.5rem;
  object-fit: contain;
  background: ${({ theme }) => theme.color.drawer.imageBackgroundColor};
  border: 0.063em solid ${({ theme }) => theme.color.drawer.imageBorderColor};
  border-radius: 0.25rem;
  box-sizing: border-box;
`;

export const ActionsPreviewContainer = styled(Col)`
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const GradientEffect = styled.div<{ isHidden: boolean }>`
  position: absolute;
  bottom: 0;
  right: 0.78rem;
  height: 8.25rem;
  width: 100%;
  border-radius: 0.25rem;
  opacity: ${({ isHidden }): number => (isHidden ? 0 : 1)};
  background: linear-gradient(
    180deg,
    ${({ theme }) => hexToRgba(theme.color.drawer.colorGradient, 0)},
    ${({ theme }) => theme.color.drawer.colorGradient} 100%
  );
  transition: opacity 0.3s ease;
  pointer-events: none;
`;
